module.exports = __webpack_public_path__ + "static/media/assignment_active.f69b7bf9.svg";